(function(angular){
	'use strict';
	
	var sharedHighchartObject = {
		template: '<div class="loader alpha coterminous fade" ng-show="sharedHighchart.loader" ng-class="{ \'in\': !sharedHighchart.loaded, \'loader--gray\': sharedHighchart.theme === \'light\' }" style="margin: auto;"></div><div class="coterminous"></div>',
		bindings: {
			chartOptions: '<',
			loader: '<',
			theme: '<'
		},
		controller: [
			'$element',
			'$scope',
			'$window',
			'Highcharts',
			'HIGHCHARTS_OPTIONS',
			SharedHighchartFunction
		],
		controllerAs: 'sharedHighchart'
	};
	
	angular
		.module('highChartsModule')
		.component('sharedHighchart', sharedHighchartObject);

	function SharedHighchartFunction(
		$element,
		$scope,
		$window,
		Highcharts, 
		HIGHCHARTS_OPTIONS
	){
		var sharedHighchart = this;
		var chart;
		var currentValue;
		var element;
		var baseHighchartsOptions;

		function initNewChart(highchartsObject) {
			element = $element[0].children[1];
			highchartsObject = angular.merge(baseHighchartsOptions, highchartsObject);
			highchartsObject.chart.events = {
				load: function() {
					$scope.$emit('highchart.load', this);
					sharedHighchart.loaded = true;
					watchForResize();
				},
				render: function() {
					$scope.$emit('highchart.render', this);
				}
			};
			highchartsObject.chart.renderTo = element;

			chart = new Highcharts.Chart(highchartsObject);
		}

		function addDataToChart(highchartsObject) {
			if(!angular.isDefined(chart)) {
				sharedHighchart.theme = sharedHighchart.theme || 'light';				
				baseHighchartsOptions = HIGHCHARTS_OPTIONS(sharedHighchart.theme);
				initNewChart(highchartsObject);
			}  else if(angular.isDefined(highchartsObject.series)) {
				chart.destroy();
				initNewChart(highchartsObject);
			}
		}

		function watchForResize() {
			$scope.$watch(function() {
				return element.clientHeight;
			}, function(newHeight) {
				if(newHeight !== chart.chartHeight) {
					chart.reflow();
				}
			});
		}

		sharedHighchart.$onChanges = function(changeObj) {
			currentValue = changeObj.chartOptions.currentValue;

			if(angular.isDefined(currentValue)) {
				addDataToChart(currentValue);
			}
		};
	}
})(window.angular);